import type { Components, Theme } from '@mui/material';

const appBarThemeConfig: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      backgroundColor: '#003B5C',
      height: '51px',
      minHeight: '51px',
    },
  },
};

const toolbarThemeConfig: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    regular: {
      height: '51px !important',
      minHeight: '51px !important',
    },
  },
};

export const muiAppBarThemeConfig = {
  MuiAppBar: {
    ...appBarThemeConfig,
  },
  MuiToolbar: {
    ...toolbarThemeConfig,
  },
};
